exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__TableHeadCell__root_component {\n  box-sizing: border-box;\n  height: 48px;\n  padding: 8px 16px;\n  text-align: left;\n  background-color: #f6f8fc;\n  border: 1px solid #dde3ed;\n}\n", ""]);

// exports
exports.locals = {
	"root_component": "DS__TableHeadCell__root_component"
};